import type { ReactNode } from "react";

import { useFormWatchAll } from "app/hooks/form/useFormWatchAll";
import { useDebugRhfStateObserver } from "app/tools/debugRHFState/hooks/useDebugRhfStateObserver";
import {
  type FieldValues,
  FormProvider as RHFormProvider,
  useForm,
  type UseFormProps,
  type WatchObserver,
} from "react-hook-form";

export type FormProviderProps<FormValues extends FieldValues> = {
  children: ReactNode;
  formName: string;
  formProps: UseFormProps<FormValues>;
  watchAll?: WatchObserver<FormValues>;
};

export const FormProvider = <FormValues extends FieldValues>({
  children,
  formName,
  formProps,
  watchAll,
}: FormProviderProps<FormValues>) => {
  const formContext = useForm<FormValues>(formProps);

  const debugRhfStateObserver = useDebugRhfStateObserver<FormValues>(
    formName,
    formContext.getValues(),
  );

  useFormWatchAll<FormValues>(formContext.watch, watchAll);
  useFormWatchAll<FormValues>(formContext.watch, debugRhfStateObserver);

  return (
    <RHFormProvider<FormValues> {...formContext}>{children}</RHFormProvider>
  );
};
